import React, { createContext, useContext, useState, useEffect } from 'react';
import { api } from '../utils/api';
import { useLocation } from 'react-router-dom';

const TrialContext = createContext();

export const useTrialContext = () => {
  const context = useContext(TrialContext);
  if (!context) {
    throw new Error('useTrialContext must be used within a TrialProvider');
  }
  return context;
};

export const TrialProvider = ({ children }) => {
  const [trialStatus, setTrialStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    // Only check trial status if user is authenticated and not on public pages
    const isPublicPage = ['/', '/login', '/register', '/privacy-policy', '/eula', '/reset-password'].includes(location.pathname);
    const isAuthenticated = localStorage.getItem('user');
    
    if (!isPublicPage && isAuthenticated) {
      const userData = JSON.parse(localStorage.getItem('user'));
      // Skip trial status check for paid accounts
      if (userData?.accountType === 'trial') {
        checkTrialStatus();
      } else {
        setLoading(false);
      }
    } else {
      // Skip API call and just set loading to false for public pages
      setLoading(false);
    }
  }, [location.pathname]);

  const checkTrialStatus = async () => {
    try {
      // Only make the API call for trial accounts
      const userData = JSON.parse(localStorage.getItem('user'));
      if (userData?.accountType === 'trial') {
        const response = await api.get('/api/v1/stem@home/trial/status');
        setTrialStatus(response.data);
      }
    } catch (error) {
      console.error('Error checking trial status:', error);
    } finally {
      setLoading(false);
    }
  };

  const checkLimit = async (type) => {
    try {
      // Only check limits for trial accounts
      const userData = JSON.parse(localStorage.getItem('user'));
      if (userData?.accountType !== 'trial') {
        return true; // Always allow for paid accounts
      }
      const response = await api.get(`/api/v1/stem@home/trial/validate/${type}`);
      return response.data.canProceed;
    } catch (error) {
      console.error('Error checking trial limit:', error);
      return false;
    }
  };

  return (
    <TrialContext.Provider value={{ trialStatus, loading, checkLimit }}>
      {children}
    </TrialContext.Provider>
  );
};

export default TrialContext; 